 <c-avatar
      *ngIf="!(UserData?.picture == '.' || UserData?.picture == '' || UserData?.picture == null ) ; else defaultAvatar"
      textColor="primary"
      shape="rounded-1"
      size="md"
      [src]="BaseService.USERIMAGESURL + UserData.picture"
      [status]="Header? 'success' : ''"
    >
    </c-avatar>
    <ng-template #defaultAvatar>
    <c-avatar
      textColor="white"
      [color]="Color"
      size="md"
      [status]="Header? 'success' : ''"
    >{{ extractInitials(UserData?.userDisplayName) }}
    </c-avatar></ng-template>